import {
  SchedulePopUpInterface,
  SchedulingProps,
  SchedulingStepsInterface,
  SchedulingWarningsProps,
} from './SchedulingInterface';
import { Box } from '@mui/material';
import { styles } from './styles';

export const SchedulingBase = ({
  page,
  pageLoading,
  setShowPopUp,
  showPopUp,
  setNextStep,
  setSchedule,
  schedule,
  loading,
  setLoading,
  setShowWarning,
  setWarningMessage,
  setIsValid,
  setRightButtonTitle,
  setRightButtonAction,
  setLeftButtonTitle,
  setLeftButtonAction,
  internalObject,
  setInternalObject,
  setCurrentStep,
  changeInternalStep,
}: SchedulingStepsInterface &
  SchedulePopUpInterface &
  SchedulingProps &
  SchedulingWarningsProps) => {
  const PageComponent = page;
  const LoadingPageComponent = pageLoading;

  const warningProps = {
    loading,
    setLoading,
    setShowWarning,
    setWarningMessage,
    setRightButtonTitle,
    setRightButtonAction,
    setLeftButtonTitle,
    setLeftButtonAction,
  };

  const commonProps = {
    setSchedule,
    schedule,
    setIsValid,
    internalObject,
    setInternalObject,
    setCurrentStep,
    changeInternalStep,
    showPopUp,
    setShowPopUp,
    setNextStep,
  };

  const pageComponent = LoadingPageComponent ? (
    <LoadingPageComponent {...commonProps} {...warningProps} />
  ) : PageComponent ? (
    <PageComponent {...commonProps} />
  ) : (
    <Box />
  );

  return <Box sx={styles.container}>{pageComponent}</Box>;
};
